import ServiceLayout from './ServiceLayout'

export default ServiceLayout
